export default __webpack_public_path__ + "static/media/longCloud8.9204868c.webp";